<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.66675 12.0002C6.66675 12.7335 7.26675 13.3335 8.00008 13.3335C8.73341 13.3335 9.33341 12.7335 9.33341 12.0002C9.33341 11.2668 8.73341 10.6668 8.00008 10.6668C7.26675 10.6668 6.66675 11.2668 6.66675 12.0002ZM6.66675 4.00016C6.66675 4.7335 7.26675 5.3335 8.00008 5.3335C8.73341 5.3335 9.33341 4.7335 9.33341 4.00016C9.33341 3.26683 8.73341 2.66683 8.00008 2.66683C7.26675 2.66683 6.66675 3.26683 6.66675 4.00016ZM8.00008 9.3335C7.26675 9.3335 6.66675 8.7335 6.66675 8.00016C6.66675 7.26683 7.26675 6.66683 8.00008 6.66683C8.73341 6.66683 9.33341 7.26683 9.33341 8.00016C9.33341 8.7335 8.73341 9.3335 8.00008 9.3335Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
